import React from 'react';
import ClassificationEntry from './ClassificationEntry';
const ClassificationGroup = ({ title, shouldRender, items, showEmpty }) => {
    return shouldRender ? (React.createElement("li", null,
        React.createElement("ul", null,
            !!title && (React.createElement("li", null,
                React.createElement("h4", null,
                    title,
                    " "))),
            !!items && items.filter(x => !!x.valueAsString || showEmpty).map((item, index) => (React.createElement(ClassificationEntry, { key: "entry_" + index, shouldRender: !!item.isVisible, title: item.label, content: showEmpty && !!!item.valueAsString ? "-" : item.valueAsString })))))) : null;
};
export default ClassificationGroup;
